"use strict";

module.exports = {
    hasPermission(userPms, permission) {
        let len = userPms.length;
        let hasPermission = false;
        if ((permission == "" || permission == null) && typeof permission != 'number') return true;
        for (let i = 0; i < len; i++) {
            if (userPms[i] == permission) {
                hasPermission = true;
                break;
            }
        }
        return hasPermission;
    },
    isSubordinate(subordinate, staffId) {
        let isSubordinate = false;
        let len = subordinate.length;
        for (let i = 0; i < len; i++) {
            if (subordinate[i] == staffId) {
                isSubordinate = true;
                break;
            }
        }

        return isSubordinate;
    },
    isUser(userId, staffId) {
        let isUser = false;
        if (userId == staffId) {
            isUser = true;
        }
        return isUser;
    },
    isMember(teamMember, staffId){
        let isMember = false;
        for(let i = 0 ; i< teamMember.length ; i++){
            if(teamMember[i] == staffId){
                isMember = true;
                break;
            }
        }

        return isMember;
    },
    hasCondo(teamCondo, mcst) {
        let hasCondo = false;
        let len = teamCondo.length;
        for (let i = 0; i < len; i++) {
            if (teamCondo[i].mcst == mcst) {
                hasCondo = true;
                break;
            }
        }
        return hasCondo;
    }
}


// WEBPACK FOOTER //
// ./app/functions/genFunction.js